import {gql} from '@apollo/client';
import {
  ComplaintOrgHubType,
  ComplaintOrgMemberDetailType,
  ComplaintOrgMemberType,
  ComplaintOrgStaffResolveType,
  ComplaintOrgViewType,
} from './types';

const MEMBER_FIELDS = `
    memberId
    accountId
    name
    countryCode
    phone
    larkUserId
    roleCode
    scopeType
    hubId
    warehouseId
    accountStatus
`;

export const GET_COMPLAINT_ORG_HUBS = gql`
    query ComplaintOrgHubs {
        complaintOrgHubs {
            id
            name
            warehouseCount
        }
    }
`;

export interface ComplaintOrgHubsResponse {
  complaintOrgHubs: ComplaintOrgHubType[];
}

export const GET_COMPLAINT_ORG_SYSTEM_ADMINS = gql`
    query ComplaintOrgSystemAdmins {
        complaintOrgSystemAdmins { ${MEMBER_FIELDS} }
    }
`;

export interface ComplaintOrgSystemAdminsResponse {
  complaintOrgSystemAdmins: ComplaintOrgMemberType[];
}

export const GET_COMPLAINT_ORG_VIEW = gql`
    query ComplaintOrgView($hubId: Long!) {
        complaintOrgView(hubId: $hubId) {
            hubRoles {
                roleCode
                members { ${MEMBER_FIELDS} }
            }
            warehouses {
                warehouseId
                warehouseName
                ticketOwners { ${MEMBER_FIELDS} }
            }
        }
    }
`;

export interface ComplaintOrgViewResponse {
  complaintOrgView: ComplaintOrgViewType;
}

export interface ComplaintOrgViewVariables {
  hubId: number;
}

export const GET_COMPLAINT_ORG_MEMBER_DETAIL = gql`
    query ComplaintOrgMemberDetail($accountId: Long!) {
        complaintOrgMemberDetail(accountId: $accountId) {
            accountId
            name
            countryCode
            phone
            accountStatus
            resolve {
                systemAccount {
                    accountId
                    loginName
                    accountStatus
                }
                larkName
                superiorPhone
                superiorLarkName
                superiorSystemAccount { accountId loginName accountStatus }
                resolveStatus
            }
            positions {
                memberId
                roleCode
                scopeType
                hubId
                hubName
                warehouseId
                warehouseName
            }
        }
    }
`;

export interface ComplaintOrgMemberDetailResponse {
  complaintOrgMemberDetail: ComplaintOrgMemberDetailType;
}

export const RESOLVE_COMPLAINT_ORG_STAFF = gql`
    query ResolveComplaintOrgStaff($countryCode: Int!, $phone: String!) {
        resolveComplaintOrgStaff(countryCode: $countryCode, phone: $phone) {
            systemAccount {
                accountId
                loginName
                accountStatus
            }
            larkUserId
            larkName
            superiorAccountId
            superiorPhone
            superiorLarkUserId
            superiorLarkName
            superiorSystemAccount { accountId loginName accountStatus }
            resolveStatus
        }
    }
`;

export interface ResolveComplaintOrgStaffResponse {
  resolveComplaintOrgStaff: ComplaintOrgStaffResolveType;
}
